import { combineReducers } from 'redux';
import { agenciesReducer, agencyReducer } from './agencyReducer';
import alert from './alertReducer';
import blocking from './blockingReducer';
import gtfsFiles from './gtfsFilesReducer';
import user from './userReducer';

const rootReducer = combineReducers({
    // short hand property names
    agencyId: agencyReducer,
    agencies: agenciesReducer,
    gtfsFiles, alert, blocking, user,
});

export type AppState = ReturnType<typeof rootReducer>;

export default rootReducer;
